<template>
    <div class="four_lang_box">
        <div class="four_lang_box_mast"></div>
        <div class="four_lang_contanin  item_scroll_hidden">
            <div v-for="(item, i) in langList" :key="i" class="foir_lang_img_item">
                <div style="display: flex;align-items: center;">
                    <img :src="`https://lingxi.enewie.com/image/${item.lang}.svg`" class="foir_lang_img_item_1" alt="">
                    <span style="font-size: 12px;margin-left: 4px;">{{ item.txt }}</span>
                </div>
                <div>
                    <img v-show="!item?.isActive" src="../assets/icon_weixuanzhong.png" width="18px" alt="">
                    <img v-show="item?.isActive" src="../assets/icon_xuanzhong_lang.png" width="18px" alt="">
                </div>
            </div>

        </div>
    </div>


</template>

<script setup>
// import { ref, onMounted } from 'vue';



const langList = [
    { lang: 1, txt: "中文 ZH", isActive: true },
    { lang: 2, txt: "English EN" },
    { lang: 3, txt: "Español ES" },
    { lang: 4, txt: "Français FR" },
    { lang: 5, txt: "عربي ، AR" },
    { lang: 6, txt: "русский RU" },
    { lang: 7, txt: "português PT" },
    { lang: 8, txt: "हिंदी HI" },
    { lang: 9, txt: "Deutsch DE" },
    { lang: 10, txt: "日本語 JA" },
    { lang: 11, txt: "한국어 KO" },
    { lang: 12, txt: "Indonesia ID" },
    { lang: 13, txt: "ภาษาไทย TH" },
]

// const data = ref(null)
// const loading = ref(true)
// const error = ref(null)

// onMounted(() => { })

// try {
//     const response = await fetch('https://lingxi.enewie.com/api/babel/getLangList')
//     if (!response.ok) throw new Error('请求失败')
//     data.value = await response.json();
//     console.log(data.value);

// } catch (err) {
//     error.value = err.message
// } finally {
//     loading.value = false
// }
</script>


<style scoped>
.four_lang_box {
    position: relative;
}

.four_lang_box_mast {
    position: absolute;
    top: 0;
    z-index: 110;
    width: 100%;
    height: 100%;
    /* background-color: antiquewhite; */
}

.four_lang_contanin {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    height: 334px;
    background-color: rgba(255, 255, 255, 0.041);
    margin: 16px 12px 0px 12px;
    overflow: auto;
    padding: 0 10px;
}

.foir_lang_img_item {
    opacity: 0.8;
    border-bottom: 1px solid rgba(0, 0, 0, 0.4);
}

.foir_lang_img_item_1 {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    object-fit: cover;
}

.foir_lang_img_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0px;
}


.item_scroll_hidden {
    overflow: auto;
    /* 或 scroll */
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
}

.item_scroll_hidden::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari */
}
</style>